export const setTelegramActiveTab = (state, action) => {
  state.tab = action.payload
}
